import React, { useEffect, useState } from 'react';
import './ProductoCard.scss'
import * as _ from 'lodash'
import { firstCharCapitalize } from '../utils/utils'
import { getVariations } from '../hooks/getVariations'
import { productInOutlet } from '../hooks/productInOutlet'

export const ProductoCard = (props) => {
    const [producto, setProducto] = useState(null)
    const allProducts = props.allProducts
    const productsTable = props.productsTable
    const [productDiameterMin, setProductDiameterMin] = useState(null)
    const [productDiameterMax, setProductDiameterMax] = useState(null)

    useEffect(() => {
      loadData().then(()=>{
        //Necesario para que se ejecute despues de crearse el componente
       })
    }, [])

    const loadData = async () => {
      return new Promise(async(resolve)=>{
        const productsChild = await getChilds()
        const product = await productInOutlet(props.producto)
        const productoBase = props.producto
        if (product !== undefined && productsChild.length <= 1) {
          productoBase.Descuento = product.Descuento
          setProducto(productoBase)
          configProduct(productoBase)
        } else {
          setProducto(productoBase)
          configProduct(productoBase)
        }
        resolve()
      })
    }

    const configProduct = async () => {
        const productsChild = await getChilds()
        const min = _.minBy(productsChild, product => {
            return parseInt(product.Diametro)
        })
        if (min !== undefined) {
            setProductDiameterMin(parseInt(min.Diametro))
        }
        const max = _.maxBy(productsChild, product => {
            return parseInt(product.Diametro)
        })
        if (max !== undefined) {
            setProductDiameterMax(parseInt(max.Diametro))
        }

    }

    const getChilds = async () => {
        return new Promise((resolve, reject) => {
            const productsChild = _.filter(allProducts, product => {
                return product.Nombre === props.producto.Nombre && product.Categoria === props.producto.Categoria
            })
            resolve(productsChild)
        })
    }

    const getVariationsStateNew = () => {
        if (producto !== undefined && producto !== null) {
            const variations = getVariations(allProducts, producto)
            const index = _.findIndex(variations, variation => {
                return variation.Estado === 'NUEVO' || variation.Estado === 'PROXIMAMENTE';
            })
            if (index > -1) {
                return true
            } else {
                return false
            }
        }
    }

    return (
        <div className={getVariationsStateNew() ? 'product-card-container  new' : 'product-card-container'}>
            {producto !== undefined && producto !== null &&
                <React.Fragment>
                    <div className="image"><img src={"/static/imgProducts/tn_" + producto.Fotografia + "_p.jpg"} onError={(e) => {
                        e.target.onerror = null
                        e.target.src = '/static/img/no-imagen-fansa.png'
                    }} alt="" /></div>
                    <div className="product-information">
                        <div className="line1">
                            <p className={getVariationsStateNew() ? 'two-span' : ''}><span>{producto.Coleccion}</span>
                                {producto.Descuento !== undefined && producto.Descuento !== '' &&
                                    <span className="discount">- {producto.Descuento}</span>
                                }
                                {getVariationsStateNew() &&
                                    <span className="new">NUEVO</span>
                                }
                            </p>
                        </div>
                        <div className="line2">
                            <p>{firstCharCapitalize(producto.Nombre)}</p>
                        </div>
                        {productsTable !== 'allProductsExpositors' && productDiameterMin !== null && productDiameterMax !== null &&
                            <div className="line3"><p>De {productDiameterMin}cm a {productDiameterMax}cm</p></div>
                        }
                    </div>
                </React.Fragment>
            }
        </div>
    )
}